import React, { useContext } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { SearchResultPlan } from "../../@types";
import { SuppressionHandler, Tooltip } from "..";
import { useTranslate, planDataUtils } from "../../helpers";
import { AppContext } from "../../app/store";

interface DeductibleProps {
  plan: SearchResultPlan;
}

const Deductible: React.FunctionComponent<DeductibleProps> = ({ plan }) => {
  const t = useTranslate();
  const { state } = useContext(AppContext);
  const { mctCurrentPlanYear } = useFlags();

  return (
    <div className="PlanCard__section" data-testid="deductible">
      <h3 className="PlanCard__section_heading">
        {t("plan_card.section_heading.deductible")}
      </h3>
      <div className="PlanCard__info_group">
        <span className="PlanCard__data">
          <SuppressionHandler plan={plan}>
            {planDataUtils.getAnnualDrugDeductible(
              state,
              mctCurrentPlanYear,
              plan
            )}
          </SuppressionHandler>
        </span>
        <Tooltip
          triggerText={t("plan_terms.drug_deductible")}
          title={t("plan_terms.drug_deductible")}
        >
          {t("plan_card.tooltip.drug_deductible")}
        </Tooltip>
      </div>
    </div>
  );
};

export default Deductible;
